import Component from '../core/Component';
import scrollToElement from '../services/Viewport/scrollToElement';
// import { scrollToElement } from '../services/Viewport';

export default class ScrollTo extends Component {

    prepare() {
        this.$element.find("a").on("click", ::this.handleClick);
        $(".scroll-down").on("click",::this.handleClick)
    }

    handleClick(event) {
        const id = event.target.getAttribute('href').replace('#', '');

        const target = document.getElementById(id);

        if (target) {
            event.preventDefault();
            scrollToElement(target);
        }
    }

}


// WEBPACK FOOTER //
// ./components/ScrollTo.js